import axios from 'axios'
import { MessageBox } from 'element-ui'
import event from '@/util/event'

const codeHandlers = {
  801() {
    event.$emit('logout')
  }
}

// 忽略显示错误的状态码，格式 { 401: 1, 403: 1 }
const ignoreCodes = {
  10001: 1
}

/**
 * 执行 ajax post 请求
 * @param {string} url
 * @param {object} data
 */
export async function post(url, data = {}) {
  const res = await axios.post(url, data)
  if (res && res.data && res.data.code === 0) {
    // 与其他 ajax 组件不一样，这里返回的是 data，而不是 { code, data, msg }
    return res.data.data || {}
  }

  // 不知道 888 有没有被后端占用，如果被后端占用，则请改成一个未被占用的状态码
  const error = res && res.data || { code: 888, msg: 'Unknown Error' }

  if (error && error.code && error.code in codeHandlers) {
    codeHandlers[error.code]()
  }

  throw error
}

/**
 * 将错误格式化成字符串
 * @param {{ code: number, msg: string } | Error | String} ex 错误对象
 */
export function formatError(ex) {
  const msg = ex.msg || String(ex)
  return msg
}

/**
 * 显示错误信息
 * @param {string} msg 错误信息
 */
export function showError(msg) {
  MessageBox.alert(msg)
}

/**
 * 统一处理 ajax catch 异常
 * @param {{ code: number, msg: string } | Error | String} ex 错误对象
 */
export function handleError(ex) {
  if (ex && !(ex.code in ignoreCodes)) {
    const msg = formatError(ex)
    showError(msg)
    console.error(ex)
  }
}



// WEBPACK FOOTER //
// ./src/util/ajax.js